import { LockOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Container, Paper, Avatar, Typography, Box, TextField, Grid } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks/reduxHooks";
import { signInUser } from "../../app/store/slices/accountSlice";
import "./Login.scss";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const {register, handleSubmit, formState: {isSubmitting, errors, isValid}} = useForm({mode: 'onTouched'});

  async function submitForm(data: FieldValues) {
    try{
      await dispatch(signInUser(data));
      navigate(location.state?.from || '/catalog');
    }catch (error) {
      console.log(error);
    }
  }

  return (
    <Container component={Paper} maxWidth='sm' className="loginContainerStyle">
      <Avatar className="loginAvatarStyle">
        <LockOutlined />
      </Avatar>
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <Box component="form" 
          onSubmit={handleSubmit(submitForm)} 
          noValidate className="loginFormStyle"
      >
        <TextField
          margin="normal"
          required
          fullWidth
          label="Username"
          {...register('username', {required: 'Username is required'})}
          error={!!errors.username}
          helperText={errors?.username?.message as string}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          label="Password"
          type="password"
          {...register('password', {required: 'Password is required'})}
          error={!!errors.password}
          helperText={errors?.password?.message as string}
        />
        <LoadingButton 
          disabled={!isValid}
          loading={isSubmitting} 
          type="submit" 
          fullWidth 
          variant="contained" className="loginLoadingButtonStyle"
        >
          Sign In
        </LoadingButton>
        <Grid container>
          <Grid item>
            <Link to='/register' style={{ textDecoration: 'none', color: "rgb(156, 39, 176)"}}>
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default LoginPage;
